import React from "react";
import classes from "./InfoWindow.module.css";

interface Props {
  modalClosed: () => void;
  infoText: string;
}

const infoWindow: React.FunctionComponent<Props> = (props) => {
  const { modalClosed, infoText } = { ...props };

  return (
    <div className={classes.popupBody}>
      <div className={classes.closeBtn} onClick={modalClosed}>
        X
      </div>
      <p>
        <strong>{infoText}</strong>
      </p>
    </div>
  );
};
export default infoWindow;
